export default __webpack_public_path__ + "static/media/contact-section.b9cd6de4.jpg";